import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    gaugeContainer: {
      position: "relative",
      width: "100%",
      textAlign: "center",
      fontFamily: theme.typography.fontFamily,
    },
    mpiTitle: {
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      textAlign: "left",
    },
    gaugeWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
    },
    gaugeSection: {
      flex: 1,
      position: "relative",
      height: "180px",
    },
    centerTextContainer: {
      position: "absolute",
      top: "95%",
      left: "51%",
      transform: "translate(-50%, -30%)",
      textAlign: "center",
      zIndex: 2,
    },
    marketPriceLabel: {
      fontSize: "12px",
      color: theme.palette.text.text_quarterary,
      fontWeight: 500,
    },
    marketPriceValueContainer: {
      display: "flex",
      justifyContent: "center",
    },
    marketPriceValue: {
      fontSize: "24px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      marginRight: "4px",
    },
    currencyLabel: {
      fontSize: "16px",
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    gaugeSvg: {
      width: "100%",
      height: "150px",
    },
    percentageContainer: {
      display: "flex",
      alignItems: "center",
      marginLeft: theme.spacing(2),
      minWidth: 80,
    },
    percentageValue: {
      fontSize: "20px",
      fontWeight: 600,
    },
  };
});
